import {
  FirmwareState,
  firmwareConverters,
} from '@iotize/tap/service/impl/firmware';
import { GET, PUT } from '../annotations';
import { CallContext, VirtualTap } from '../virtual-tap-server';

export class FirmwareService {
  constructor(public server: VirtualTap) {}

  @GET({
    path: '/5//3',
    responseType: firmwareConverters.firmwareState,
  })
  public getFirmwareState(context: CallContext<void>) {
    return this.server.getFirmwareState();
  }

  @PUT({
    path: '/5//3',
    payloadType: firmwareConverters.firmwareState,
  })
  public putFirmwareState(context: CallContext<FirmwareState>) {
    this.server.setFirmwareState(context.body);
  }
}
